import React from 'react';
import Swiperslider from '../Swiperslider/Index';
import ImageTag from '../ImageTag/Index';
import './index.css';
import Title from '../Title/Index';
import { Link } from 'react-router-dom';

const Index = ({ Data, bgImage }) => {
  return (
    <>
      <div className={`col-12 float-start p-100 blueLayer ${bgImage}`}>
        <div className='Number_Section position-relative col-lg-6 col-sm-10 col-11 m-auto'>
          <Title 
            firstHeading={Data.heading} 
            secondHeading={Data.title} 
            subTitle={Data.descp} 
            _class={'text-white m-0'} 
            _secondHeading={'text-white'} 
            _spanClass={'text-white'} 
            Subheading={true} 
            sub_title={Data.sub_title} 
          />
          <div className='col-12 float-start flex-center' data-aos="fade-up" data-aos-offset="100" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine">
                                  <Link to='/our-clients'><span className='customButton text-white'>Know More</span></Link>
                                </div>
        </div>
      </div>

      {Array.isArray(Data.clientLogo) && Data.clientLogo.length > 0 && (
        <div className='col-lg-10 col-12 m-auto clientLogo mt-lg-5 mt-3'>
          <Swiperslider 
            spaceBetween={1} 
            slidesPerView={5}
            navigation={false} 
            pagination={false} 
            timeDelay={8000}
            tabsliderperview={4}
            smallsliderperview={3}
            mobsliderperview={2}
          >
            {Data.clientLogo.map((logo, index) => (
              <div 
                className='col-11 text-center flex-center p-lg-3 p-2 border bg-white logoSlide flex-wrap' 
                key={index}
              >
                <ImageTag 
                  ImagePath={logo.imagePath} 
                  ImageAlt={logo.imageAlt} 
                  ImageWidth={192}
                  ImageHeight={100}
                                  />
                 <ImageTag 
                  ImagePath={logo.supporting_doc} 
                  ImageAlt={'Bottle Lebal Long Rider'} 
                  ImageClass={'bottleLable'}
                  ImageWidth={192}
                  ImageHeight={250}
                                  />                 

              </div>
            ))}
          </Swiperslider>
        </div>
      )}
    </>
  );
};

export default Index;
